/**
 * "Check your email": shown after sign-up, and to a signed-in person whose
 * address is not verified yet (the API refuses everything else until it is).
 */

import { useState, type ReactNode } from 'react';

import { LoginShell } from '../login/LoginShell.tsx';
import { resendVerification } from './signup-api.ts';

export function CheckEmail({
  email,
  signedIn,
  onContinue,
  onSignOut,
}: {
  email: string;
  signedIn: boolean;
  onContinue: () => void;
  onSignOut?: () => void;
}): ReactNode {
  const [note, setNote] = useState<string | null>(null);
  return (
    <LoginShell>
      <header className="li-head">
        <h1>Check your email</h1>
        <p>
          We sent a link to {email ? <strong>{email}</strong> : 'your email address'}. Click it to
          verify your address
          {signedIn ? ', then come back here.' : ', then sign in.'}
        </p>
      </header>
      {note && (
        <div className="li-notice" role="status">
          {note}
        </div>
      )}
      <div className="li-form">
        <button className="li-submit" type="button" onClick={onContinue}>
          {signedIn ? 'I have verified — continue →' : 'Go to sign in →'}
        </button>
        {signedIn && (
          <p className="li-after">
            No email?{' '}
            <button
              type="button"
              className="li-link"
              onClick={() =>
                void resendVerification()
                  .then(() => setNote('A new link is on its way. It lasts 24 hours.'))
                  .catch(() => setNote('The email could not be sent. Try again in a minute.'))
              }
            >
              Send it again
            </button>
            {onSignOut && (
              <>
                {' · '}
                <button type="button" className="li-link" onClick={onSignOut}>
                  Sign out
                </button>
              </>
            )}
          </p>
        )}
      </div>
    </LoginShell>
  );
}
